"use strict";

module.exports = function (accumulator, order, product, component) {
  if (component.ink_color && component.has_addressing) {
    return accumulator + "".concat(component.ink_color === 'Black' ? 'Black' : component.ink_color.toUpperCase(), "\n");
  }

  return accumulator;
};